require('./accountCertificates.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ commons
const { FormattedText } = require('core/i18n').i18n;
const DocumentsTable = require('components/myProfile/documentsTable/documentsTable');

class AccountCertificates extends React.Component {
    constructor(props) {
        super(props);
        this.buildDocumentList = this.buildDocumentList.bind(this);
    }

    buildDocumentList() {
        const { documents } = this.props;

        return (
            <DocumentsTable
                data={documents}
                showAlias={false}
                showCurrentDocument={false}
                showDocumentationType={true}
                showAutoDates={false}
                callbackDownloadFile={this.props.callbackDownloadFile}
                hideDateCell={true}
                hideTableHeader={true}
            />
        );
    }

    render() {
        const { className } = this.props;
        const certificateClass = `account-certificates ${className}`
        return (
            <article className={certificateClass}>
                <section>
                    <h3 className="account-certificates__title">
                        <FormattedText value="certificateSection-title" />
                    </h3>
                    {this.buildDocumentList()}
                </section>
            </article>
        );
    }
}

AccountCertificates.propTypes = {
    callbackDownloadFile: PropTypes.func,
    isFetching: PropTypes.bool,
    documents: PropTypes.object,
    className: PropTypes.string
};

module.exports = AccountCertificates;
